import { GE } from '@ezugi/constants';

import {
  userSelector, gameIdSelector, tableIdSelector, roundIdSelector,
} from '../../selectors';

import type { RootState } from '../../types';

// this function can be moved to packages/bootstrap/src/store/epics/socket/utils.js after file is ported to ts

/** returns payload for action `socket.send` */
export const buildSocketSendPayload = (state: RootState) => {
  const user = userSelector(state);
  return {
    ClientId: user.clientId,
    // note that for most games, GE expects `ClientIP`, but there are also games where GE expects `ClientIp` and games where this field is optional
    ClientIP: user.clientIp,
    CurrentPlayerToken: user.currentPlayerToken,
    MessageType: GE.OUT.SOCKET_SEND.MESSAGE_TYPE.PLACE_BET,
    destination: GE.OUT.SOCKET_SEND.DESTINATION.PLAYER,
    gameType: gameIdSelector(state),
    // TODO what should happen when tableIdSelector (state.table.id) is undefined?
    TableId: tableIdSelector(state)?.toString(),
    // note that for some games, GE expects `roundId` as a string, not number
    roundId: roundIdSelector(state),
  };
};
